export const isLiveDemoFf = (branch) => branch.name === 'cisluna-live';
export const isLiveDemo = (branch) => isLiveDemoFf(branch) || branch.name === 'ors1-tlm-live';
